/**
 * Deep merge utility for combining base templates with device-specific overrides
 * Preserves arrays and handles nested objects correctly
 */

export function deepMerge(target, ...sources) {
	if (!sources.length) return target;
	const source = sources.shift();

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) Object.assign(target, { [key]: {} });
				deepMerge(target[key], source[key]);
			} else if (Array.isArray(source[key])) {
				// Replace arrays completely rather than merging
				target[key] = [...source[key]];
			} else {
				Object.assign(target, { [key]: source[key] });
			}
		}
	}

	return deepMerge(target, ...sources);
}

function isObject(item) {
	return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Add capabilities to existing template without replacing
 */
export function addCapabilities(base, additions) {
	const result = { ...base };

	if (additions.actions) {
		result.actions = { ...base.actions, ...additions.actions };
	}

	if (additions.conditions) {
		result.conditions = { ...base.conditions, ...additions.conditions };
	}

	if (additions.triggers) {
		result.triggers = { ...base.triggers, ...additions.triggers };
	}

	return result;
}
